import { NoPermissionTranslations } from "./types";

export const enTranslations: NoPermissionTranslations = {
    title: "You don't have permission to see this page",
    message:
        "This is the admin panel. Your account does not have an admin role, so there is nothing here for you.",
    back: "Back to login",
};
